import FnrFetch2 from "Utilities/FnrFetch/FnrFetch2.js";
import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3.js";

let API = {
  getDashboardSettings: () => new FnrFetch2("/dashboard/settings?ajax"),
  getPaymentsStatus: () => new FnrFetch2("/fundit/getFundItStatus"),
  rsvpForPaymentsLiveLaunch: () => new FnrFetch3("/fundit/rsvp"),
};

export default API;
